var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-parameter-log"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("パラメータログ")])])],1),_c('ParameterPassingLogList',{attrs:{"type":'default'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }